import React from 'react';

import { DatePicker } from 'material-ui-pickers';

import TextField from '@material-ui/core/TextField';
import InputLabel from '@material-ui/core/InputLabel';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import LinearProgress from '@material-ui/core/LinearProgress';

import AppContent from '../_Shared/Layout/AppContent';
import Select from '../_Shared/SearchableDropdown'

const _ = require('lodash');

class CampaignEdit extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            campaign: props.campaign
        }
    }

    componentDidMount() {
        this.props.onActivate();
    }

    componentDidUpdate(prevProps, prevState) {
        const { campaign } = this.props;
        if (campaign !== null && !_.isEqual(prevProps.campaign, campaign)) {
            this.setState({ campaign });
        }
    }

    handleInputChange = (name, value) => {
        this.setState((prevState, state) => {
            return { campaign: Object.assign({}, prevState.campaign, { [name]: value }) }
        });
    }

    updateCampaign = e => {
        const { onCampaignUpdated } = this.props;
        const { campaign } = this.state;
        onCampaignUpdated(campaign);
    }

    render() {
        const { loading } = this.props;
        const { campaign } = this.state;
        return (<AppContent>
                    <Grid container spacing={24}>
                        {
                            loading &&
                            <Grid container item spacing={24}><Grid item xs><LinearProgress variant="query" color="secondary" /></Grid></Grid>
                        }
                        <Grid container item spacing={24}>
                            <Grid item lg={6} xl={4}>
                                <TextField autoFocus value={campaign.name} onChange={e => this.handleInputChange('name', e.target.value)} id="name" name="name" label="Campaign Name" type="text" fullWidth />
                            </Grid>
                        </Grid>
                        <Grid container item spacing={24}>
                            <Grid item lg={6} xl={4}>
                                <InputLabel>{campaign.advertiser.name}</InputLabel>
                            </Grid>
                        </Grid>
                        <Grid container item spacing={24}>
                            <Grid item lg={6} xl={4}>
                            {
                                campaign.advertiser.brands &&
                                <Grid item xs>
                                    <Select options={[].concat(campaign.advertiser.brands).map(x => { return { 'label': x, 'value': x } })} value={campaign.brand} name="brand" label="Brand"
                                        onChange={value => this.handleInputChange('brand', value)} placeholder="Please select a Brand" />
                                </Grid>
                            }
                                {/* <TextField autoFocus value={campaign.name} onChange={e => this.handleInputChange('brand', e.target.value)} id="brand" name="brand" label="Campaign Name" type="text" fullWidth /> */}
                            </Grid>
                        </Grid>
                        <Grid container item spacing={24} >
                            <Grid item lg={3} xl={2}>
                                <DatePicker autoOk label="Start Date" id="startDate" name="startDate" value={campaign.startDate} format="DD/MM/YYYY"
                                    onChange={value => this.handleInputChange('startDate', value)} animateYearScrolling={false} />
                            </Grid>
                            <Grid item lg={3} xl={2}>
                                <DatePicker autoOk label="End Date" id="endDate" name="endDate" value={campaign.endDate} format="DD/MM/YYYY"
                                    onChange={value => this.handleInputChange('endDate', value)} animateYearScrolling={false} />
                            </Grid>
                        </Grid>

                        <Grid container item spacing={24}>
                            <Grid item lg={6} xl={4}>
                                <Button onClick={this.updateCampaign} variant="contained" color="secondary">Save</Button>
                            </Grid>
                        </Grid>
                    </Grid>
                </AppContent >)
    }
}

export default CampaignEdit;


// WEBPACK FOOTER //
// ./src/Components/Presentation/Campaigns/CampaignEdit.js